import { render, staticRenderFns } from "./dictionaryResearchEdit.vue?vue&type=template&id=fba7e7ae&scoped=true&"
import script from "./dictionaryResearchEdit.vue?vue&type=script&lang=js&"
export * from "./dictionaryResearchEdit.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryResearchEdit.vue?vue&type=style&index=0&id=fba7e7ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba7e7ae",
  null
  
)

export default component.exports